import * as React from 'react'
import { Button, Form, Pagination, PaginationProps, Segment, Table } from 'semantic-ui-react'
import { adminService } from '../../../../../services'
import { toast } from 'react-toastify'
import { common } from '../../../../../utils/common'

type HistoryTransactionState = {
  data: ITransactionSearchInfo,
  totalPage: number,
  pageData?: IPageable<ITransaction>,
  isLoading: boolean
}

export class HistoryTransaction extends React.Component {
  state: HistoryTransactionState = {
    data: {
      username: '',
      page: 0,
    },
    totalPage: 1,
    isLoading: false
  }

  renderHeader = () => {
    return (
      <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Username</Table.HeaderCell>
        <Table.HeaderCell>Thời gian</Table.HeaderCell>
        <Table.HeaderCell>Loại giao dịch</Table.HeaderCell>
        <Table.HeaderCell>Trạng thái</Table.HeaderCell>
        <Table.HeaderCell>Số tiền</Table.HeaderCell>
        <Table.HeaderCell>Thông tin</Table.HeaderCell>
        <Table.HeaderCell>Chi tiết</Table.HeaderCell>
      </Table.Row>
    </Table.Header>)
  }

  renderDetail = (data: ITransaction): string => {
    if (data.type === 'SUB') {
      if (data.rollRequest) {
        return `Mua item: ${data.rollRequest.itemNameList}`
      }
      return ''
    }
    if (data.depRequest) {
      return `Nạp tiền ${data.depRequest.amount} với mã nạp: ${data.depRequest.id}`
    }
    return ''
  }

  renderBody = (data?: IPageable<ITransaction>) => {
    if (!data) {
      return (<Table.Row>No Data</Table.Row>)
    }

    return data.content.map(transaction => (
      <Table.Row>
        <Table.Cell>{transaction.user.username}</Table.Cell>
        <Table.Cell>{common.toLocaleDateTime(transaction.createdAt)}
        </Table.Cell>
        <Table.Cell>{transaction.type}</Table.Cell>
        <Table.Cell>{transaction.status}</Table.Cell>
        <Table.Cell negative={transaction.type === 'SUB'} positive={transaction.type === 'ADD'}>
          {transaction.amount ? transaction.amount.toLocaleString('vn') : ''}
        </Table.Cell>
        <Table.Cell>{transaction.message}</Table.Cell>
        <Table.Cell>{this.renderDetail(transaction)}</Table.Cell>
      </Table.Row>
    ))
  }

  getHistoryTransaction = (dataSearch: ITransactionSearchInfo) => {
    this.setState({isLoading: true})
    adminService.getHistoryTransacion(dataSearch)
      .then(transaction => {
        this.setState({
          pageData: transaction,
          totalPage: transaction.totalPages,
          isLoading: false,
        })
      })
      .catch(error => {
        toast.error(error.message)
        this.setState({isLoading: false})
      })
  }

  onDataChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const {name, value} = event.target
    const {data} = this.state
    data[name] = value
    this.setState({data})
  }

  onSearch = () => {
    this.getHistoryTransaction(this.state.data)
  }

  handlePageChange = (event: React.MouseEvent<HTMLAnchorElement>, data: PaginationProps) => {
    let dataRequest = this.state.data
    if (!data.activePage || data.activePage <= 0) {
      dataRequest.page = 0
    } else {
      dataRequest.page = Number(data.activePage) - 1
    }
    this.getHistoryTransaction(dataRequest)
  }

  render() {
    const {data, totalPage, pageData, isLoading} = this.state
    return (
      <Segment loading={isLoading}>
        <Form>
          <Form.Group inline={true}>
            <Form.Field
              control={'input'}
              label="From Date"
              name="startDate"
              onChange={this.onDataChange}
              type="date"
            />
            <Form.Field
              control={'input'}
              label="To Date"
              name="endDate"
              onChange={this.onDataChange}
              type="date"
            />
          </Form.Group>
          <Form.Group inline={true}>
            <Form.Field
              control={'input'}
              label="Username"
              name={'username'}
              value={data.username}
              onChange={this.onDataChange}
            />
            <Form.Field label="Loại" control="select" name={'type'} onChange={this.onDataChange}>
              <option value={undefined}/>
              <option value="ADD">Nạp tiền</option>
              <option value="SUB">Roll/Mua Item</option>
            </Form.Field>
            <Form.Field label="Trạng thái" control="select" name={'status'} onChange={this.onDataChange}>
              <option value={undefined}/>
              <option value="PENDING">Chờ xử lý</option>
              <option value="SUCCESS">Thành công</option>
              <option value="FAIL">Thất bại</option>
            </Form.Field>
          </Form.Group>
          <Button type="submit" onClick={this.onSearch}>Search</Button>
        </Form>
        <Table>
          {this.renderHeader()}
          {this.renderBody(pageData)}
        </Table>
        <Pagination
          totalPages={totalPage}
          activePage={data.page + 1}
          onPageChange={this.handlePageChange}
        />
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/HistoryTransaction.tsx